import i18next from 'i18next'

export const projectGeneralFormTabs = (isEdit: boolean) => {
    const { t } = i18next

    const tabs = [
        { id: 1, name: 'general', label: t('app.common.generalInfo') },
        { id: 2, name: 'description', label: t('app.common.description') },
        { id: 3, name: 'map', label: t('form.common.tab.map'), disabled: !isEdit },
        {
            id: 4,
            name: 'materials',
            label: t('form.common.tab.materials'),
            disabled: !isEdit,
            children: [
                { id: '4-1', name: 'photos', label: t('app.common.photos') },
                { id: '4-2', name: 'groundPlans', label: t('app.common.groundPlans') },
                { id: '4-3', name: '3dVideo', label: t('form.common.tab.3dVideo') },
            ],
        },
        { id: 5, name: 'documents', label: t('app.common.documents'), disabled: !isEdit },
    ]
    return tabs
}

export const projectViewTabs = () => {
    const { t } = i18next
    return [
        { id: 1, name: 'about', label: t('view.project.tab.about') },
        { id: 2, name: 'notes', label: t('app.common.notes') },
        { id: 3, name: 'documents', label: t('app.common.documents') },
        { id: 4, name: 'relatedProperties', label: t('app.common.relatedProperties') },
        { id: 5, name: 'activities', label: t('app.common.activities') },
    ]
}
